import React from 'react';

const CssProvider = React.createContext<[any, any]>([{}, {}]);

export default CssProvider;